// @ts-nocheck

import { downloadRequestWithToken, fetchRequest } from './index';
/**
 * Получение отчета
 */
export const fetchReportBusinessTrips = async params => {
  const report = await fetchRequest.get('/report/businessTrips', {
    ...params
  });
  return report;
};

/**
 * Печать отчета
 */
export const printReportBusinessTrips = async params => {
  const isPrinted = await downloadRequestWithToken('/report/businessTrips/print', {
    ...params
  });
  if (isPrinted) return true;
  throw new Error('Не удалось загрузить отчет');
};

/**
 * Запросить данные командировок
 */
export const fetchData = async params => {
  const sended = await fetchRequest.get('/order/parus/updateOrders', {
    ...params
  });
  if (sended) return true;
  throw new Error('Не отправить данные');
};
export default {
  fetchReportBusinessTrips,
  printReportBusinessTrips,
  fetchData
};
